function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable complexity */
import BaseChannel, { channelsHost } from '@square/dashboard-data/adapters/channels/base-channel';
export default class PlatformObject extends BaseChannel {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "namespace", 'api/v1/channels');
  }
  pathForType() {
    return 'platform-objects';
  }
  query(modelName, query, options) {
    const {
      objectType = 'ITEM_VARIATION',
      filters = {},
      cursor,
      limit
    } = options.adapterOptions;
    return this.searchV1(objectType, filters, cursor, limit);
  }
  searchV1(objectType = 'ITEM_VARIATION', filters = {}, cursor, limit = 25) {
    const requestBody = {
      object_type: objectType,
      limit
    };
    if (Object.keys(filters).length > 0) {
      requestBody.query = {
        filter: {
          ...filters
        }
      };
    }
    if (cursor) {
      requestBody.cursor = cursor;
    }
    const url = `${this.buildURL('channels/platform-object', null)}/search`;
    return this.ajax(url, 'POST', {
      data: requestBody
    });
  }
  async search(objectType = 'ITEM_VARIATION', filters = {}, cursor, limit = 25) {
    const requestBody = {
      limit,
      object_type: objectType
    };
    if (Object.keys(filters).length > 0) {
      requestBody.filter = {
        ...filters
      };
    }
    if (cursor) {
      requestBody.cursor = cursor;
    }
    const url = `${channelsHost}/api/v2/channels/platform-objects/search`;
    const response = await this.ajax(url, 'POST', {
      data: requestBody
    });
    return response;
  }
  updateAttributes(platformObjectId, changeset) {
    const requestBody = {
      batches: [{
        objects: [{}]
      }]
    };
    const objectToUpdate = requestBody.batches[0].objects[0];
    const hasFieldChange = changeset.change.hasOwnProperty.bind(changeset.change);
    const hasItemChanges = ['description', 'parent_name'].some(hasFieldChange);
    if (hasItemChanges) {
      const itemUpdate = {
        id: changeset.get('parent_id')
      };
      if (hasFieldChange('description')) {
        itemUpdate.description = changeset.get('description');
      }
      if (hasFieldChange('parent_name')) {
        itemUpdate.name = changeset.get('parent_name');
      }
      objectToUpdate.item_data = itemUpdate;
    }
    const hasVariantChanges = ['upc', 'amount', 'brand', 'color', 'age_group', 'gender', 'condition', 'is_bundle', 'multipack', 'size'].some(hasFieldChange);
    if (hasVariantChanges) {
      const itemVariationUpdate = {
        id: changeset.get('id'),
        custom_attribute_values: {}
      };
      if (hasFieldChange('amount')) {
        itemVariationUpdate.price_money = {
          amount: changeset.change.amount === '' ? null : Math.round(100 * Number.parseFloat(changeset.change.amount.replace(/[$,]/g, '')))
        };
      }
      if (hasFieldChange('upc')) {
        itemVariationUpdate.upc = changeset.change.upc;
      }
      if (hasFieldChange('age_group')) {
        itemVariationUpdate.custom_attribute_values.channels_age_group = {
          selection_uid_values: changeset.change.age_group === null ? [] : [changeset.change.age_group]
        };
      }
      if (hasFieldChange('brand')) {
        itemVariationUpdate.custom_attribute_values.channels_brand = {
          string_value: changeset.change.brand
        };
      }
      if (hasFieldChange('color')) {
        itemVariationUpdate.custom_attribute_values.channels_color = {
          string_value: changeset.change.color
        };
      }
      if (hasFieldChange('condition')) {
        itemVariationUpdate.custom_attribute_values.channels_condition = {
          selection_uid_values: changeset.change.condition === null ? [] : [changeset.change.condition]
        };
      }
      if (hasFieldChange('gender')) {
        itemVariationUpdate.custom_attribute_values.channels_gender = {
          selection_uid_values: changeset.change.gender === null ? [] : [changeset.change.gender]
        };
      }
      if (hasFieldChange('is_bundle')) {
        itemVariationUpdate.custom_attribute_values.channels_is_bundle = {
          boolean_value: changeset.change.is_bundle
        };
      }
      if (hasFieldChange('multipack')) {
        itemVariationUpdate.custom_attribute_values.channels_multipack = {
          number_value: String(changeset.change.multipack ?? '')
        };
      }
      if (hasFieldChange('size')) {
        itemVariationUpdate.custom_attribute_values.channels_size = {
          string_value: changeset.change.size
        };
      }
      if (Object.keys(itemVariationUpdate.custom_attribute_values).length === 0) {
        delete itemVariationUpdate.custom_attribute_values;
      }
      objectToUpdate.item_variation_data = itemVariationUpdate;
    }
    const url = `${channelsHost}/api/v1/channels/sq-connect/item-variation/update/${platformObjectId}`;
    return this.ajax(url, 'POST', {
      data: requestBody
    });
  }
}